/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商品名称">
        <el-input
          size="small"
          v-model="formInline.CommodityName"
          placeholder="输入商品名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="状态">
        <el-select
          v-model="formInline.goodsState"
          @change="resetData"
          placeholder="请选择状态"
        >
          <el-option label="全部" value="0"></el-option>
          <el-option label="已上架" value="1"></el-option>
          <el-option label="已下架" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品类别">
        <el-select
          v-model="formInline.goodsType"
          @change="resetData1"
          placeholder="请选择商品类别"
        >
          <!-- <el-option label="全部" value="0"></el-option> -->
          <el-option label="拍卖" value="1"></el-option>
          <el-option label="一口价" value="2"></el-option>
          <el-option label="专场" value="3"></el-option>
          <el-option label="盲盒" value="4"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      v-if="formInline.goodsType == 1 || formInline.goodsType == 2"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
      height='64vh'
    >
      <el-table-column prop="CommodityType" label="商品类别"> </el-table-column>
      <el-table-column
        prop="CommodityPicURL"
        label="商品主图"
        min-width="100px"
      >
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.CommodityPicURL"
            style="width: 100px; height: 100px"
            :src="goodUrl + scope.row.CommodityPicURL"
            fit="scale-down"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="CommodityName" label="商品标题"></el-table-column>
      <el-table-column
        prop="CommodityPrice"
        :label="formInline.goodsType == 2 ? '商品售价' : '起拍价'"
      ></el-table-column>
      <el-table-column prop="CommodityState" label="状态">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleChange(scope.$index, scope.row)"
            >{{ scope.row.CommodityState }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="EndTime"
        label="截止时间"
        v-if="formInline.goodsType == 1"
      ></el-table-column>

      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleToUp(scope.$index, scope.row)"
            >置顶</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="deleteFn(scope.$index, scope.row)"
            v-if="scope.row.CommodityState == '已下架'"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-table
      size="small"
      :data="listData"
      v-if="formInline.goodsType == 3"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="SpecialSessionName" label="商品类别">
        <template>
          <div>专场</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="SpecialSessionPicURL"
        label="商品主图"
        min-width="100px"
      >
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.SpecialSessionPicURL"
            style="width: 100px; height: 100px"
            :src="SpecialPic + scope.row.SpecialSessionPicURL"
            fit="scale-down"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="SpecialSessionCommoditys"
        label="专场商品"
        min-width="200px"
      >
        <template slot-scope="scope">
          <div
            v-for="(item, i) in scope.row.SpecialSessionCommoditys"
            :key="i"
            :guid="item.CommodityGUID"
          >
            {{ (i * 1 + 1) + "、" + item.CommodityName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="SpecialSessionState" label="状态">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleChange(scope.$index, scope.row)"
            >{{ scope.row.SpecialSessionState }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="StartTime" label="开始时间"></el-table-column>
      <el-table-column prop="EndTime" label="截止时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="scope.row.SpecialSessionState == '已下架'"
            @click="deleteFn(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-table
      size="small"
      :data="listData"
      v-if="formInline.goodsType == 4"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="BlindBoxName" label="商品类别">
        <template>
          <div>盲盒</div>
        </template>
      </el-table-column>
      <el-table-column prop="BlindBoxPicURL" label="商品主图" min-width="100px">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.BlindBoxPicURL"
            style="width: 100px; height: 100px"
            :src="SpecialPic + scope.row.BlindBoxPicURL"
            fit="scale-down"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="BlindBoxCommoditys"
        label="盲盒商品"
        min-width="200px"
      >
        <template slot-scope="scope">
          <div
            v-for="(item, i) in scope.row.BlindBoxCommoditys"
            :key="i"
            :guid="item.CommodityGUID"
          >
            {{ (i * 1 + 1) + "、" + item.CommodityName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="BlindBoxName" label="商品标题"></el-table-column>
      <el-table-column prop="BlindBoxPrice" label="盲盒金额"></el-table-column>
      <el-table-column prop="RecoveryRatio" label="回收比例"></el-table-column>
      <el-table-column prop="IsRecovery" label="是否回收">
        <template slot-scope="scope">
          <span>{{ scope.row.IsRecovery == 1 ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="BlindBoxState" label="状态">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleChange(scope.$index, scope.row)"
            >{{ scope.row.BlindBoxState }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="StartTime" label="开始时间"></el-table-column>
      <el-table-column prop="EndTime" label="结束时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="scope.row.BlindBoxState == '已下架'"
            @click="deleteFn(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
		<mPage :page="pageparm.page" :total="pageparm.total" @change="changePage"></mPage>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="1000px"
      
      @close="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        ref="editForm"
        class="flex flex_wrap"
      >
        <div style="width: 900px">
          <el-form-item
            label="商品标题"
            v-if="editForm.goodsType < 3"
            prop="CommodityName"
            :rules="[
              { required: true, message: '请输入商品标题', trigger: 'blur' },
            ]"
          >
            <el-input
              size="small"
              v-model="editForm.CommodityName"
              auto-complete="off"
              placeholder="请输入商品标题"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="专场标题"
            prop="SpecialSessionName"
            v-if="editForm.goodsType == 3 && editForm.isPic < 1"
            :rules="[
              { required: true, message: '请输入专场标题', trigger: 'blur' },
            ]"
          >
            <el-input
              size="small"
              v-model="editForm.SpecialSessionName"
              auto-complete="off"
              placeholder="请输入专场标题"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="盲盒标题"
            prop="BlindBoxName"
            v-if="editForm.goodsType == 4"
            :rules="[
              { required: true, message: '请输入盲盒标题', trigger: 'blur' },
            ]"
          >
            <el-input
              size="small"
              v-model="editForm.BlindBoxName"
              auto-complete="off"
              placeholder="请输入盲盒标题"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item
          label="商品类别"
          prop="goodsType"
          :rules="[
            { required: true, message: '请选择商品类别', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="editForm.goodsType"
            placeholder="请选择商品类别"
            :disabled="editForm.goodsType > 2"
            @change="changeGoodsType"
          >
            <el-option
              v-for="item in editForm.goodsTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="有无专场图片"
          prop="isPic"
          v-if="editForm.goodsType == 3"
        >
          <el-select
            v-model="editForm.isPic"
            placeholder="请选择有无图片"
            :disabled="editForm.SpecialGuid != ''"
            :rules="[
              { required: true, message: '请选择有无图片', trigger: 'blur' },
            ]"
            @change="changePicType"
          >
            <el-option label="无专场图" value="0"></el-option>
            <el-option label="有专场图" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="商品分类"
          prop="CommodityTypeName"
          v-if="editForm.goodsType < 3"
        >
          <el-select
            v-model="editForm.CommodityTypeName"
            placeholder="请选择商品分类"
            value-key="CommodityTypeGUID"
            @change="changeCommodityType"
          >
            <el-option
              v-for="(item, i) in commodityTypeList"
              :key="i"
              :label="item.CommodityTypeName"
              :value="item.CommodityTypeGUID"
            ></el-option>
          </el-select>
        </el-form-item>
        <div style="width: 900px">
          <el-form-item
            label="商品描述"
            prop="CommodityDescription"
            v-if="editForm.goodsType < 3"
          >
            <el-input
              size="small"
              type="textarea"
              clearable
              autosize
              v-model="editForm.CommodityDescription"
              auto-complete="off"
              placeholder="请输入商品描述"
            ></el-input>
          </el-form-item>
        </div>
        <div style="width: 900px">
          <el-form-item
            label="商品轮播图"
            prop="picList"
            v-if="editForm.goodsType < 3"
          >
            <el-upload
              class="editor-upload mb20"
              ref="upload"
              multiple
              :limit="10000"
              action=""
              list-type="picture-card"
              :file-list="editForm.picList"
              :before-upload="beforeUpload"
              :auto-upload="false"
              :on-change="uploadImg"
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleImgToUp(file, 1)"
                  >
                    <i class="el-icon-top"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, 1)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
              <div slot="tip">上传图片</div>
            </el-upload>

            <el-upload
              class="editor-upload"
              ref="upload"
              action=""
              :limit="1"
              :before-upload="beforeUploadVideo"
              :file-list="editForm.videoList"
              :auto-upload="false"
              :on-success="handleVideoSuccess"
              :on-progress="uploadVideoProcess"
              :on-change="uploadVideo"
              :on-remove="handleRemove"
            >
              <div
                v-if="editForm.videoList && editForm.videoList.length < 1"
                slot="default"
                class="el-upload--picture-card"
              >
                <i class="el-icon-plus"></i>
              </div>
              <div slot="tip">上传视频</div>
              <el-progress
                v-if="videoFlag == true"
                class="progressed"
                type="circle"
                :percentage="videoUploadPercent"
                style="margin-top: 30px"
              ></el-progress>
              <video
                v-if="
                  editForm.videoList &&
                  editForm.videoList.length > 0 &&
                  videoFlag == false
                "
                width="360"
                heihht="180"
                :src="editForm.videoList && editForm.videoList[0].url"
                class="avatar"
                controls="controls"
              >
                您的浏览器不支持视频播放
              </video>
            </el-upload>
          </el-form-item>
        </div>
        <div style="width: 900px">
          <el-form-item
            label="产品详情图"
            prop="detailList"
            v-if="editForm.goodsType < 3"
          >
            <el-upload
              class="editor-upload"
              ref="upload"
              action=""
              multiple
              :limit="10000"
              list-type="picture-card"
              :file-list="editForm.detailList"
              :before-upload="beforeUpload"
              :auto-upload="false"
              :on-change="uploadImg1"
              type-name="detailList"
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleImgToUp(file, 2)"
                  >
                    <i class="el-icon-top"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, 2)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <!-- 拍卖 -->
        <template v-if="editForm.goodsType == 1">
          <el-form-item label="立即开始" prop="atSellSwitch">
            <el-switch
              v-model="editForm.atSellSwitch"
              @change="changeAtSellSwitch"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            label="开始时间"
            prop="StartTime"
            v-if="!editForm.atSellSwitch"
            :rules="[
              {
                required: !editForm.atSellSwitch,
                message: '请输入开始时间',
                trigger: 'blur',
              },
            ]"
          >
            <el-date-picker
              v-model="editForm.StartTime"
              type="datetime"
              placeholder="选择立即开始时间"
              @change="changeTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="截止时间"
            prop="EndTime"
            :rules="[
              { required: true, message: '请输入截止时间', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="editForm.EndTime"
              type="datetime"
              placeholder="选择截止时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="起拍价"
            prop="StartingPrice"
            :rules="[
              { required: true, message: '请选择起拍价', trigger: 'blur' },
            ]"
          >
            <el-input-number
              v-model="editForm.StartingPrice"
              :min="0"
              placeholder="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="底价" prop="ReservePrice">
            <el-input-number
              v-model="editForm.ReservePrice"
              :min="0"
              placeholder="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="加价幅度"
            prop="PriceIncreaseRange"
            :rules="[
              { required: true, message: '请选择商品分类', trigger: 'blur' },
            ]"
          >
            <el-input-number
              v-model="editForm.PriceIncreaseRange"
              :min="0"
              placeholder="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="红包(%)" prop="RedPackets">
            <el-input-number
              v-model="editForm.RedPackets"
              :min="0"
              placeholder="0"
            ></el-input-number>
          </el-form-item>
        </template>
        <el-form-item
          label="会员价"
          prop="VipPrice"
          v-if="editForm.goodsType == 2"
        >
          <el-input-number
            v-model="editForm.VipPrice"
            :min="0"
            placeholder="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="一口价"
          prop="Price"
          v-if="editForm.goodsType == 2"
          :rules="[
            { required: true, message: '请选择商品分类', trigger: 'blur' },
          ]"
        >
          <el-input-number
            v-model="editForm.Price"
            :min="0"
            placeholder="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="原价"
          prop="OriginalPrice"
          v-if="editForm.goodsType < 3"
          :rules="[
            {
              required: editForm.goodsType == 2,
              message: '请选择商品分类',
              trigger: 'blur',
            },
          ]"
        >
          <el-input-number
            v-model="editForm.OriginalPrice"
            :min="0"
            placeholder="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="分润(%)"
          prop="SharePercentage"
          v-if="editForm.goodsType < 3"
        >
          <el-input-number
            v-model="editForm.SharePercentage"
            :min="0"
            placeholder="0"
          ></el-input-number>
        </el-form-item>
        <div class="flex" style="width: 900px" v-if="editForm.goodsType < 3">
          <el-form-item
            label="成交后自动下架"
            prop="AutomaticOffShelf"
            v-if="editForm.goodsType == 2"
          >
            <el-switch
              v-model="editForm.AutomaticOffShelf"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="七天包退" prop="Guaranteed7Days">
            <el-switch
              v-model="editForm.Guaranteed7Days"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="包邮" prop="FreeShipping">
            <el-switch
              v-model="editForm.FreeShipping"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            label="保证金"
            prop="Bond"
            v-if="editForm.goodsType == 1"
          >
            <el-input-number
              v-model="editForm.Bond"
              :min="0"
              placeholder="0"
            ></el-input-number>
          </el-form-item>

          <!-- 拍卖 -->
        </div>
        <!-- 盲盒 -->
        <div v-if="editForm.goodsType > 2">
          <div style="width: 900px; padding-bottom: 40px">
            <el-form-item
              label=""
              prop="SpecialSessionPicURL"
              v-if="
                editForm.goodsType == 4 ||
                (editForm.goodsType == 3 && editForm.isPic == 1)
              "
            >
              <el-upload
                class="editor-upload editor-upload1"
                ref="upload"
                action=""
                :limit="1"
                :before-upload="beforeUpload"
                :show-file-list="false"
                :on-remove="handleRemove4"
                :on-change="uploadImg4"
                type-name="SpecialSessionPicURL"
              >
                <div
                  v-if="editForm.SpecialSessionPicURL != ''"
                  class="upload1-avatar"
                >
                  <i
                    class="el-icon-close absolute"
                    @click.stop="
                      DeleteBlindBoxCommoditysFn(editForm.SpecialSessionPicURL)
                    "
                  ></i>
                  <el-image
                    fit="contain"
                    :src="SpecialPic + editForm.SpecialSessionPicURL"
                    class="upload1-avatar"
                    @click.stop="stop = false"
                  ></el-image>
                </div>
                <i v-else slot="default" class="el-icon-plus"></i>
                <div slot="tip" class="gray">
                  请用2:1的尺寸进行设计上传。建议尺寸为700×350
                </div>
              </el-upload>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item
              label="开始时间"
              v-if="!editForm.atSellSwitch"
              :rules="[
                {
                  required: !editForm.atSellSwitch,
                  message: '请输入开始时间',
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                v-model="editForm.StartTime"
                type="datetime"
                placeholder="选择立即开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="截止时间"
              prop="EndTime"
              :rules="[
                { required: true, message: '请输入截止时间', trigger: 'blur' },
              ]"
            >
              <el-date-picker
                v-model="editForm.EndTime"
                type="datetime"
                placeholder="选择截止时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </div>

          <el-form-item
            label="盲盒金额"
            prop="BlindBoxPrice"
            :rules="[
              { required: true, message: '请输入盲盒金额', trigger: 'blur' },
            ]"
            v-if="editForm.goodsType == 4"
          >
            <el-input-number
              v-model="editForm.BlindBoxPrice"
              :min="0"
              placeholder="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="回收比例"
            prop="RecoveryRatio"
            v-if="editForm.goodsType == 4"
          >
            <el-input-number
              v-model="editForm.RecoveryRatio"
              :min="0"
              placeholder="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="是否回收"
            prop="IsRecovery"
            v-if="editForm.goodsType == 4"
          >
            <el-switch
              v-model="editForm.IsRecovery"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="" v-if="editForm.goodsType == 4">
            <el-input
              placeholder="搜索商品关键词"
              prefix-icon="el-icon-search"
              v-model="editForm.searchName"
              @change="getGoodsList"
            >
            </el-input>
            <div class="flex-andmid" style="margin-top: 20px">
              <div class="leftContent scrollBox">
                <div>
                  <div>商品列表</div>
                  <div class="scrollView">
                    <el-radio-group
                      v-model="editForm.choosedArr"
                      @change="handleChecked"
                    >
                      <el-radio
                        v-for="item in goodsList"
                        :label="item.CommodityGUID"
                        :key="item.CommodityGUID"
                        >{{ item.CommodityName }}</el-radio
                      >
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div class="centerContent flex-sb">
                <!-- <div class="arrow" :class="[editForm.choosedArr1.length > 0 ?'arrow1':'']" @click="toLeft"><i
                    class="el-icon-arrow-left"></i>
                </div> -->
                <div
                  class="arrow"
                  :class="[editForm.choosedArr != '' ? 'arrow1' : '']"
                  @click="toRight"
                >
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="rightContent scrollBox">
                <div>开奖列表</div>
                <div class="scrollView">
                  <el-radio-group
                    v-model="editForm.choosedArr1"
                    @change="handleChecked1"
                  >
                    <div
                      v-for="(item, i) in goodsList1"
                      :key="i"
                      class="flex-sb"
                    >
                      <el-radio :label="item.CommodityGUID + i">{{
                        item.CommodityName
                      }}</el-radio>
                      <i
                        class="el-icon-close fz14"
                        @click="deleteGoodsFn(item, i)"
                      ></i>
                    </div>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <!-- <el-transfer filterable
            :left-default-checked="editForm.choosedArr" :titles="['商品列表', '中奖列表']" target-order="push" :right-default-checked="editForm.choosedArr" @change="handleChangeGoodsList"
              filter-placeholder="请输入商品关键词" v-model="editForm.choosedArr" :data="goodsList">
            </el-transfer> -->
          </el-form-item>
          <el-form-item label="" v-if="editForm.goodsType == 3">
            <el-input
              placeholder="搜索商品关键词"
              prefix-icon="el-icon-search"
              v-model="editForm.searchName"
              @change="getGoodsList"
            >
            </el-input>
            <ul class="goodsUl">
              <li
                v-for="(item, i) in goodsList"
                class="goodsLi flex-andmid"
                :class="{ activeGoods: item.active }"
                :key="i"
                @click="chooseFn(item, i)"
              >
                <!-- specialInfo -->
                <el-image
                  fit="contain"
                  :src="goodUrl + item.CommodityPicURL"
                  class="goodsImg"
                  @click.stop="stop = false"
                ></el-image>
                <div>
                  <div class="title">{{ item.CommodityName }}</div>
                  <div>{{ item.CommodityPrice }}</div>
                  <div class="flex-sb">
                    <span class="CommodityNature">{{
                      item.CommodityNature
                    }}</span>
                    <span class="gray">热度{{ item.CommodityHot }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
let editForm = {
  isPic: "0",
  searchName: "",
  goodsType: 1,
  CommodityDescription: "",
  OriginalPrice: 0,
  VipPrice: "",
  SharePercentage: "",
  CommodityName: "",
  Guaranteed7Days: 0,
  Price: "",
  AutomaticOffShelf: 0,
  atSellSwitch: 0,
  Number: "",
  StartTime: "",
  EndTime: "",
  ReservePrice: "",
  StartingPrice: "",
  PriceIncreaseRange: "",
  RedPackets: "",
  Bond: "",
  ShopPicURL: [],
  MultimediaURL: [],
  FreeShipping: 0,
  picList: [],
  detailList: [],
  videoList: [],
  CommodityTypeName: "",
  CommodityTypeGUID: "",
  CommodityGUID: "",
  SpecialSessionPicURL: "",
  choosedArr: "",
  choosedArr1: "",
  BlindBoxCommoditys: [],
  BlindBoxGUID: "",
  BlindBoxName: "",
  SpecialSessionGUID: "",
  SpecialGuid: "",
  goodsTypes: [
    {
      label: "拍卖",
      value: "1",
    },
    {
      label: "一口价",
      value: "2",
    },
  ],
};

import Pagination from "../../components/Pagination";
import mPage from "../../components/mPage"
// import dialogFom from "./dialogFom"
export default {
  data() {
    return {
      videoFlag: false,
      // 进度百分比
      videoUploadPercent: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      imgUrl: this.$imgUrl,
      goodUrl: this.$goodUrl,
      videoUrl: this.$videoUrl,
      SpecialPic: this.$SpecialPic,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm,
      formInline: {
        page: 1,
        limit: 10,
        CommodityName: "",
        goodsState: "0",
        goodsType: "1",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        limit: 10,
        total: 10,
      },
      type: 1,
      canNext:true,
      personInfo: {},
      commodityTypeList: [],
      delFileList: [],
      candelete: true,
      isnew: 1,
      pgoodsType: "",
      goodsList: [],
      goodsList1: [],
    };
  },
  // 注册组件
  components: {
    // Pagination,
    mPage,
    // dialogFom
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.nextTime();
    this.personInfo = JSON.parse(this.$util.getStore("personInfo"));
  },
  mounted() {
    this.getCategoryList();
    this.search();
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    
			changePage(e, i) {
        let {total,page}=this.pageparm;
        if (e == 1) {
            page--;
            this.canNext = page < 1 ? false : true;
        } else {
            if (this.canNext) {
                page++;
            } else {
              total = page;
            }
        }
        this.pageparm.page = page;
        this.pageparm.total = total;
        if (this.canNext) {
            this.search();
        }
			},
    chooseFn(e, i) {
      e.active = !e.active;
      this.goodsList[i] = e;
    },
    DeleteBlindBoxCommoditysFn(e) {
      this.$confirm("此操作将更改原有盲盒的只要图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.DeleteBlindBoxCommoditys(e);
          this.editForm.SpecialSessionPicURL = "";
        })
        .catch(() => {});
    },
    DeleteBlindBoxCommoditys(e) {
      let sqlCmdName = "ShopWebApp\\DeleteBlindBoxCommoditys_1_0_1&DBC=w_m";
      let data = {
        BlindBoxGUID: e,
      };
      this.$loading();
      this.$api.ExSqlFn(sqlCmdName, data).then((res) => {
        let result = res.data;
        if (result.OK != "True") {
          this.$message(result.Message);
        }
        this.$loading().close();
      });
    },
    deleteGoodsFn(guid, i) {
      let { BlindBoxGUID } = this.editForm;
      if (BlindBoxGUID && BlindBoxGUID != "" && guid != "") {
        this.DeleteBlindBoxCommoditys(guid);
      }
      this.goodsList1.splice(i, 1);
    },
    toRight() {
      let { choosedArr, choosedArr1, BlindBoxGUID } = this.editForm,
        goodsList1 = this.goodsList1;
      if (choosedArr != "") {
        let item = this.goodsList.find((v) => v.CommodityGUID == choosedArr);
        if (choosedArr1 != "") {
          if (BlindBoxGUID != "") {
            this.$confirm("此操作将更改原有盲盒的开奖商品, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                choosedArr1 = choosedArr1.substring(0, choosedArr1.length - 1);
                this.DeleteBlindBoxCommoditys(choosedArr1);
                let i = goodsList1.findIndex(
                  (v) => v.CommodityGUID == choosedArr1
                );
                goodsList1[i] = item;
                this.goodsList1 = goodsList1;
              })
              .catch(() => {});
          } else {
            choosedArr1 = choosedArr1.substring(0, choosedArr1.length - 1);
            let i = goodsList1.findIndex((v) => v.CommodityGUID == choosedArr1);
            goodsList1[i] = item;
            this.goodsList1 = goodsList1;
          }
        } else {
          goodsList1.push(item);
          this.goodsList1 = goodsList1;
        }
        this.editForm.choosedArr = "";
        this.editForm.choosedArr1 = "";
      }
    },
    handleChecked(e) {
      this.editForm.choosedArr = e;
    },
    handleChecked1(e) {
      this.editForm.choosedArr1 = e;
    },
    resetData() {
      this.listData = [];
      this.pageparm = {
        page: 1,
        limit: 10,
        total: 10,
      };
    },
    resetData1(e) {
      this.resetData();
      this.editForm.goodsTypes = this.returnGoodsTypes(e);
    },
    returnGoodsTypes(e) {
      let goodsTypes = [];
      if (e == 2 || e == 1) {
        goodsTypes = [
          {
            label: "拍卖",
            value: "1",
          },
          {
            label: "一口价",
            value: "2",
          },
        ];
      } else if (e == 3) {
        goodsTypes = [
          {
            label: "专场",
            value: "3",
          },
        ];
      } else if (e == 4) {
        goodsTypes = [
          {
            label: "盲盒",
            value: "4",
          },
        ];
      }
      return goodsTypes;
    },
    changePicType(e) {
      let { SpecialSessionGUID, isPic, SpecialSessionPicURL } = this.editForm;
      if (SpecialSessionGUID == "") {
        isPic = e;
      } else {
        isPic = SpecialSessionPicURL == "" ? 0 : 1;
      }
      this.editForm.isPic = isPic;
    },
    changeGoodsType(e) {
      //选择商品类别
      let { CommodityGUID, goodsType } = this.editForm;

      if (goodsType < 3) {
        if (CommodityGUID != "" && goodsType != this.pgoodsType) {
          this.$confirm(
            "此操作将更改该商品类型并发布成新的商品, 是否继续?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.editForm.CommodityGUID = "";
              this.candelete = true;
              this.isnew = 0;
            })
            .catch(() => {
              this.editForm.goodsType = this.pgoodsType;
            });
        }
      } else {
        this.getGoodsList();
      }
    },
    // 获取类别
    getCategoryList: function () {
      let data = {
        CompanyGUID: this.personInfo.CompanyGUID,
      };

      this.$loading();
      this.$api.GetCommodityTypeList(data).then(
        (res) => {
          this.$loading().close();
          let result = res.data;
          if (result.OK != "True") {
            this.$message({
              type: "success",
              message: result.Message,
            });
          } else if (result.Tag.length <= 0) {
          } else {
            this.commodityTypeList = result.Tag[0].Table;
          }
        },
        function (err) {},
        "GET"
      );
    },

    handleChange(index, data) {
      console.log(data, 742);
      let m =
        data.CommodityState || data.SpecialSessionState || data.BlindBoxState;
      m = m == "已上架" ? "下架" : "上架";
      console.log(m, 742, data);
      this.$confirm("此操作将" + m + "该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.updateStatus(data, index);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消" + m,
          });
        });
    },
    updateStatus(e, i) {
      let { goodsType } = this.formInline;
      let sqlCmdName = "ShopWebApp\\UpdateLotCommodityState_1_0_1",
        key =
          goodsType == 3
            ? "SpecialSessionState"
            : goodsType == 4
            ? "BlindBoxState"
            : "CommodityState",
        newState = e[key] == "已上架" ? "已下架" : "已上架",
        kGuid =
          goodsType == 3
            ? "SpecialSessionGuid"
            : goodsType == 4
            ? "BlindBoxGUID"
            : "CommodityGUID";
      let currentGuid = e[kGuid];

      let data = {
        CommodityGUID: currentGuid,
        CommodityState: newState,
      };
      if (goodsType == 2) {
        sqlCmdName = "ShopWebApp\\UpdateOrdinaryCommodityState_1_0_1";
      } else if (goodsType == 3) {
        data = {
          SpecialSessionGUID: e.SpecialSessionGUID,
          SpecialSessionState: newState,
        };
        sqlCmdName = "ShopWebApp\\UpdateSpecialSessionState_1_0_1";
      } else if (goodsType == 4) {
        data = {
          BlindBoxGUID: currentGuid,
          BlindBoxState: newState,
        };
        sqlCmdName = "ShopWebApp\\UpdateBlindBoxState_1_0_1";
      }
      this.$loading();
      this.$api.ExSqlFn(sqlCmdName + "&DBC=w_m", data).then((res) => {
        let { data } = res;
        this.$loading().close();
        if ((data.OK = "True")) {
          this.listData[i].CommodityState = newState;
          this.$message({
            type: "success",
            message: newState.substring(1, 3) + "成功!",
          });
          this.search();
        } else {
          this.$message({
            type: "success",
            message: newState.substring(1, 3) + "失败!",
          });
        }
      });
    },
    changeCommodityType(e) {
      this.editForm.CommodityTypeGUID = e;
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.limit = parm.limit;
      this.search(this.formInline);
    },
    // 搜索事件
    search() {
      let { goodsType, goodsState, CommodityName } = this.formInline,
        CommodityState = "全部";
      let sqlCmdName = "ShopWebApp\\GetLotCommodityList_1_0_1";
      if (goodsType == 1) {
        CommodityState = "拍卖";
      } else if (goodsType == 2) {
        CommodityState = "一口价";
        sqlCmdName = "ShopWebApp\\GetOrdinaryCommodityList_1_0_1";
      } else if (goodsType == 3) {
        CommodityState = "盲盒";
        sqlCmdName =
          "ShopWebApp\\GetSpecialSessionList_1_0_1,ShopWebApp\\GetSpecialSessionCommoditys_1_0_1";
      } else if (goodsType == 4) {
        CommodityState = "专场";
        sqlCmdName =
          "ShopWebApp\\GetBlindBoxList_1_0_1,ShopWebApp\\GetBlindBoxCommoditys_1_0_1";
      }
      let { CompanyGUID, ShopGUID } = this.personInfo,
        { page, limit, total } = this.pageparm;
        if(CommodityName!=''){
          CommodityName=CommodityName.trim()
        }
        console.log(CommodityName,1444)
      let data = {
        ShopGUID,
        CompanyGUID,
        CommodityState:
          goodsState == 1 ? "已上架" : goodsState == 2 ? "已下架" : "全部",
        CommodityName,
        PageNumber: page-1,
      };
      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        this.$loading().close();
        let data = res.data;
        if (data.OK == "True" && data.Tag && data.Tag.length > 0) {
          this.listData = data.Tag[0].Table;
          this.canNext=true
          console.log(sqlCmdName, 854, this.listData);
        } else {
          this.listData = [];
          this.canNext=false
        }
      });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      let { goodsType } = this.formInline;
      goodsType = goodsType > 0 ? goodsType : this.editForm.goodsType;
      console.log(row,1462)
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        if (goodsType > 2) {
          this.editForm.goodsType = goodsType;
          this.selectedGoods = [];
          this.goodsList = [];
          this.editForm.SpecialGuid =
            row.BlindBoxGUID || row.SpecialSessionGUID;
          console.log(this.editForm, 872);
          this.getGoodsList();
        } else {
          this.getGoodsDetail(row);
        }
      } else {
        this.title = "添加";
        this.delFileList = [];
        this.editForm = editForm;
        this.editForm.goodsTypes = this.returnGoodsTypes(goodsType);
        this.editForm.goodsType = goodsType;
        if (goodsType > 2) {
          this.getGoodsList();
        }
      }
    },

    //获取商品信息
    getGoodsDetail: function (e) {
      let goodsType = "1",
        { CommodityType } = e;
      let sqlCmdName =
        "ShopWebApp\\GetLotCommodityInfo_1_0_2,ShopWebApp\\GetCommodityMultimediaInfo_1_0_1,ShopWebApp\\GetCommodityDetailsPagePic_1_0_1";
      if (CommodityType == "一口价") {
        goodsType = "2";
        sqlCmdName =
          "ShopWebApp\\GetOrdinaryCommodityInfo_1_0_2,ShopWebApp\\GetCommodityMultimediaInfo_1_0_1,ShopWebApp\\GetCommodityDetailsPagePic_1_0_1";
      }
      let data = {
        CommodityGUID: e.CommodityGUID,
      };
      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&&DBC =r_m", data).then((res) => {
        this.$loading().close();
        let result = res.data;
        if (result.OK != "True") {
          this.$message(result.Message);
        } else if (result.Tag.length <= 0) {
          this.$message("获取信息失败");
        } else {
          let goodsInfo = result.Tag[0].Table[0];
          let picList = goodsInfo.CommodityMultimedias;

          let detailList = goodsInfo.CommodityDetailsPagePics;
          let arr = [],
            arr1 = [];
          picList.forEach((item) => {
            item.name = item.MultimediaURL;
            if (item.MultimediaType == "image") {
              item.url = this.goodUrl + item.MultimediaURL;
              item.name = item.MultimediaURL;
              arr.push(item);
            } else {
              item.url = this.videoUrl + item.MultimediaURL;
              item.name = item.MultimediaURL;
              arr1.push(item);
            }
          });
          detailList.forEach((item) => {
            item.url = this.goodUrl + item.CommodityDetailsPagePicURL;
            item.name = item.CommodityDetailsPagePicURL;
            item.MultimediaURL = item.CommodityDetailsPagePicURL;
            item.MultimediaType = "image";
          });
          goodsInfo.picList = arr;
          goodsInfo.videoList = arr1;
          goodsInfo.detailList = detailList;
          goodsInfo.goodsType = goodsType;
          goodsInfo.SharePercentage = goodsInfo.SharePercentage * 100;
          goodsInfo.RedPackets = goodsInfo.RedPackets * 100;
          goodsInfo.Guaranteed7Days =
            goodsInfo.Guaranteed7Days == 1 ? true : false;
          goodsInfo.FreeShipping = goodsInfo.FreeShipping == 1 ? true : false;
          goodsInfo.AutomaticOffShelf =
            goodsInfo.AutomaticOffShelf == 1 ? true : false;
          goodsInfo.OriginalPrice = goodsInfo.OriginalPrice
            ? goodsInfo.OriginalPrice
            : 0;
          goodsInfo.atSellSwitch = 0;
          goodsInfo.goodsTypes = this.returnGoodsTypes(goodsType);
          this.pgoodsType = goodsType;
          this.editForm = goodsInfo;
        }
      });
    },
    handleToUp(i, data) {
      let guid = data.CommodityGUID;
      let data1 = {
        CommodityGUID: guid,
      };
      this.$loading();
      this.$api
        .ExSqlFn("ShopWebApp\\TopUpCommodity_1_0_1&&DBC=w_m", data1)
        .then((res) => {
          this.$loading().close();
          let result = res.data;
          if (result.OK != "True") {
            this.$message(result.Message);
          } else {
            let listData = this.listData;
            let item = null;
            listData.forEach((el, idx) => {
              if (el.CommodityGUID == guid) {
                item = el;
                listData.splice(idx, 1);
              }
            });
            listData.unshift(item);
            this.listData = listData;
          }
        });
    },
    changeAtSellSwitch(e) {
      this.editForm.atSellSwitch = e;
    },
    timestampToTime() {
      var now = new Date(),
        y = now.getFullYear(),
        month = now.getMonth(),
        d = now.getDate(),
        h = now.getHours(),
        m = now.getMinutes(),
        s = now.getSeconds();
      return y + "-" + (month + 1) + "-" + d + " " + h + ":" + m + ":" + s;
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      console.log(this.editForm, 929);
      this.$refs[editData].validate((valid) => {
        if (valid) {
          if (this.editForm.goodsType > 2) {
            this.submitBlindBox();
          } else {
            this.submitFormFn();
          }
        } else {
          return false;
        }
      });
    },

    submitBlindBox() {
      //发布盲盒信息
      let nowTime = new Date();
      let { StartTime, EndTime, goodsType ,atSellSwitch} = this.editForm,
        specialInfo = this.editForm;
      console.log(atSellSwitch,159)
      if(atSellSwitch){
        StartTime=this.timestampToTime()
      }
      if (new Date(EndTime).getTime() - new Date(StartTime).getTime() <= 0) {
        this.$message("截止时间需在开始时间之后");
        return;
      }
      if ((new Date(EndTime).getTime()+1000) - nowTime.getTime() <= 0) {
        this.$message("截止时间需在当前时间之后");
        return;
      }
      if (goodsType == 3) {
        if (specialInfo.isPic < 1) {
          if (
            !specialInfo.SpecialSessionName ||
            specialInfo.SpecialSessionName == ""
          ) {
            this.$message("专场名称不能为空");
            return;
          }
        } else {
          if (!specialInfo.SpecialSessionPicURL) {
            this.$message("专场图片不能为空");
            return;
          }
        }
        let goodsList1 = [];
        this.goodsList.forEach((item) => {
          if (item.active) {
            goodsList1.push(item);
          }
        });
        this.goodsList1 = goodsList1;
        if (goodsList1.length <= 2) {
          this.$message("专场商品不能小于3个");
          return;
        }
        this.judgeAddorEditBlind(specialInfo, StartTime, EndTime);
      } else if (goodsType == 4) {
        if (!specialInfo.BlindBoxName || specialInfo.BlindBoxName == "") {
          this.$message("盲盒名称不能为空");
          return;
        }
        if (!specialInfo.SpecialSessionPicURL) {
          this.$message("盲盒图片不能为空");
          return;
        }
        if (
          specialInfo.IsRecovery &&
          (!specialInfo.RecoveryRatio || specialInfo.RecoveryRatio == 0)
        ) {
          this.$message("请设置大于0的盲盒的回收比例");
          return;
        }
        if (!specialInfo.BlindBoxPrice || specialInfo.BlindBoxPrice == "") {
          this.$message("盲盒金额必须大于0");
          return;
        }
        if (this.goodsList1 == 0) {
          this.$message("盲盒商品不能小于1个");
          return;
        }
        this.submitBlind(StartTime, EndTime, specialInfo);
        return;
      }
    },

    //盲盒发布
    setSubmitDataFn: function (
      specialInfo,
      startTime,
      endTime,
      specialGuid,
      newSpecialGuid
    ) {
      let personInfo = this.personInfo;
      let selectedGoods = this.goodsList1;
      let transactionName = "";
      let Parameter2 = [];
      for (let i in selectedGoods) {
        let obj = {
          SpecialSessionGUID: specialGuid || newSpecialGuid,
          CommodityGUID: selectedGoods[i].CommodityGUID,
        };
        Parameter2.push(obj);
      }
      let data = [
        {
          SqlCmdName: "ShopWebApp\\UpdateSpecialSessionInfo_1_0_1",
          DBC: "w_m",
          Parameter: "",
        },
        {
          SqlCmdName: "ShopWebApp\\InsertSpecialSessionCommoditys_1_0_1",
          DBC: "w_m",
          Parameter: JSON.stringify(Parameter2),
        },
      ];
      let Parameter1 = [
        {
          SpecialSessionGUID: specialGuid || newSpecialGuid,
          SpecialSessionName:
            specialInfo[
              specialInfo.goodsType == 4 ? "BlindBoxName" : "SpecialSessionName"
            ] || "",
          StartTime: startTime,
          EndTime: endTime,
          SpecialSessionPicURL: specialInfo.SpecialSessionPicURL || "",
          ShopGUID: personInfo.ShopGUID,
          CompanyGUID: personInfo.CompanyGUID,
        },
      ];
      data[0].Parameter = JSON.stringify(Parameter1);
      if (specialGuid == "") {
        transactionName = "发布专场";
        this.releaseSpecial(transactionName, data);
      } else {
        transactionName = "修改专场";
        this.DeleteSpecialSessionCommoditys(specialGuid, transactionName, data);
      }
    },

    DeleteSpecialSessionCommoditys: function (
      specialGuid,
      transactionName,
      submitaData
    ) {
      let sqlCmdName =
        "ShopWebApp\\DeleteSpecialSessionCommoditys_1_0_1&DBC=w_m";
      let data = [
        {
          SpecialSessionGUID: specialGuid,
        },
      ];
      this.$api.ExSqlFn(sqlCmdName, data).then((res) => {
        let result = res.data;
        if (result.OK != "True") {
          this.$message(result.Message);
        } else {
          this.releaseSpecial(transactionName, submitaData);
        }
      });
    },
    judgeAddorEditBlind(specialInfo, startTime, endTime) {
      let specialGuid = specialInfo.SpecialGuid;
      let newSpecialGuid = "";
      if (specialGuid != "") {
        this.setSubmitDataFn(
          specialInfo,
          startTime,
          endTime,
          specialGuid,
          newSpecialGuid
        );
      } else {
        this.$api.returnGuid().then((guid) => {
          this.setSubmitDataFn(
            specialInfo,
            startTime,
            endTime,
            specialGuid,
            guid
          );
        });
      }
    },
    submitBlind(StartTime, EndTime, specialInfo) {
      //盲盒发布
      let specialGuid = specialInfo.SpecialGuid;
      if (specialGuid == "") {
        this.$api.returnGuid().then((guid) => {
          this.upDateBlind(
            guid,
            this.goodsList1,
            StartTime,
            EndTime,
            specialInfo.SpecialSessionPicURL
          );
        });
      } else {
        this.upDateBlind(
          specialGuid,
          this.goodsList1,
          StartTime,
          EndTime,
          specialInfo.SpecialSessionPicURL
        );
      }
    },

    upDateBlind(guid, blindList, StartTime, EndTime, BlindBoxPicURL) {
      let info = this.editForm;
      let Parameter = [
        {
          BlindBoxGUID: guid,
          BlindBoxName: info.BlindBoxName ? info.BlindBoxName : "",
          StartTime,
          EndTime,
          BlindBoxPicURL,
          ShopGUID: this.personInfo.ShopGUID,
          CompanyGUID: this.personInfo.CompanyGUID,
          BlindBoxPrice: info.BlindBoxPrice,
          RecoveryRatio: info.RecoveryRatio ? info.RecoveryRatio / 100 : 0,
          IsRecovery: info.IsRecovery ? 1 : 0,
        },
      ];
      let submitaData = [
        {
          SqlCmdName: "ShopWebApp\\UpdateBlindBoxInfo_1_0_1",
          DBC: "w_m",
          Parameter: JSON.stringify(Parameter),
        },
      ];
      console.log(blindList, 106777);
      blindList.forEach((item, IDX) => {
        let obj = [
          {
            BlindBoxGUID: guid,
            CommodityGUID: item.CommodityGUID,
            IDX: IDX * 1 + 1,
          },
        ];
        let param = {
          SqlCmdName: "ShopWebApp\\InsertBlindBoxCommoditys_1_0_1",
          DBC: "w_m",
          Parameter: JSON.stringify(obj),
        };
        submitaData.push(param);
      });
      this.releaseSpecial("发布/修改盲盒信息", submitaData);
    },
    //获取商品信息
    getSpecialDetail: function (goodsType) {
      let { SpecialGuid } = this.editForm;
      let sqlCmdName =
        goodsType == 3
          ? "ShopWebApp\\GetSpecialSessionInfo_1_0_1,ShopWebApp\\GetSpecialSessionCommoditys_1_0_1"
          : "ShopWebApp\\GetBlindBoxInfo_1_0_1,ShopWebApp\\GetBlindBoxCommoditys_1_0_1";
      let data = {};
      let key = goodsType == 3 ? "SpecialSessionGUID" : "BlindBoxGUID";
      data[key] = SpecialGuid;
      console.log(sqlCmdName, data, 803);
      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        this.$loading().close();

        let result = res.data;
        if (result.OK != "True") {
          this.$message(result.Message);
        } else if (result.Tag.length <= 0) {
        } else {
          let specialInfo = result.Tag[0].Table[0];
          specialInfo.choosedArr1 = [];
          specialInfo.SpecialGuid = SpecialGuid;
          if (goodsType == 4) {
            this.goodsList1 = specialInfo.BlindBoxCommoditys;
            specialInfo.RecoveryRatio = specialInfo.RecoveryRatio * 100;
            specialInfo.SpecialSessionPicURL = specialInfo.BlindBoxPicURL;
            specialInfo.IsRecovery = specialInfo.IsRecovery == 1 ? true : false;
          } else {
            this.selectedGoods = specialInfo.SpecialSessionCommoditys;
            this.setGoodsList();
            specialInfo.isPic =
              specialInfo.SpecialSessionPicURL == "" ? "0" : "1";
          }
          specialInfo.goodsType = goodsType;
          specialInfo.goodsTypes = this.returnGoodsTypes(goodsType);
          this.editForm = specialInfo;
        }
      });
    },
    setGoodsList() {
      let selectedGoods = this.selectedGoods;
      let goodsList = this.goodsList.concat(selectedGoods);

      goodsList = this.removeDuplicateObj(goodsList, "CommodityGUID");
      for (let i in goodsList) {
        for (let j in selectedGoods) {
          if (goodsList[i].CommodityGUID == selectedGoods[j].CommodityGUID) {
            goodsList[i].active = true;
          }
        }
      }
      this.goodsList = goodsList;
    },
    removeDuplicateObj(arr, key) {
      //去重

      let obj = {};
      arr = arr.reduce((newArr, next) => {
        obj[next[key]] ? "" : (obj[next[key]] = true && newArr.push(next));
        return newArr;
      }, []);
      return arr;
    },
    submitFormFn() {
      let goodsInfo = this.editForm;
      let {picList,goodsType,atSellSwitch} = goodsInfo;
      console.log(atSellSwitch,goodsInfo,goodsType)
      if (picList.length == 0) {
        this.$message("图片不能为空");
        return;
      }
      if (goodsType == 1&&!atSellSwitch && goodsInfo.StartTime == "") {
        this.$message("请选择开始时间");
        return;
      }
      if (!goodsInfo.CommodityName || goodsInfo.CommodityName == "") {
        this.$message("商品名称不能为空");
        return;
      }
      if (
        !goodsInfo.CommodityDescription ||
        goodsInfo.CommodityDescription == ""
      ) {
        this.$message("商品描述不能为空");
        return;
      }

      if (
        (!goodsInfo.VipPrice || parseFloat(goodsInfo.VipPrice) == 0) &&
        goodsType == 2
      ) {
        this.$message("会员价需大于0");
        return;
      }
      if (goodsInfo.SharePercentage != "" && goodsInfo.SharePercentage < 1) {
        this.$message("分润最小1%");
        return;
      }
      if (goodsInfo.SharePercentage != "" && goodsInfo.SharePercentage > 100) {
        this.$message("分润最大100%");
        return;
      }
      if (goodsType == 1) {
        this.submitAuction(picList, goodsInfo);
      } else if (goodsType == 2) {
        this.submitPrice(picList, goodsInfo);
      }
    },

    nextTime() {
      var time = new Date(this.timestampToTime());
      var b = 2; //分钟数
      time.setMinutes(time.getMinutes() + b, time.getSeconds(), 0);
      var date = time;
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1);
      var day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      var hour = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
      var min =
        date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
      var sec =
        date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
      var todayDate =
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
      return todayDate;
    },

    submitAuction: function (picList, goodsInfo) {
      let nowTime = new Date();
      let { StartTime, EndTime } = goodsInfo;
      if (goodsInfo.atSellSwitch) {
        goodsInfo.StartTime = this.nextTime();
      }
      if (new Date(StartTime).getTime() - nowTime.getTime() <= 0) {
        this.$message("开始时间需在当前时间之后");
        return;
      }
      if (new Date(EndTime).getTime() - nowTime.getTime() <= 0) {
        this.$message("截止时间需在当前时间之后");
        return;
      }
      if (new Date(EndTime).getTime() - new Date(StartTime).getTime() <= 0) {
        this.$message("截止时间需在开始时间之后");
        return;
      }

      if (goodsInfo.StartingPrice < 0) {
        this.$message("起拍价不能小于0");
        return;
      }
      if (goodsInfo.ReservePrice < 0) {
        this.$message("底价不能小于0");
        return;
      }
      if (goodsInfo.RedPackets != "" && goodsInfo.RedPackets > 100) {
        this.$message("红包最大占比100%");
        return;
      }
      if (
        !goodsInfo.PriceIncreaseRange ||
        goodsInfo.PriceIncreaseRange == "" ||
        goodsInfo.PriceIncreaseRange <= 0
      ) {
        this.$message("加价幅度不能为空或小于等于0");
        return;
      }
      // console.log('发布商品信息');
      // console.log(goodsInfo);
      this.judgeAddorEdit(picList, goodsInfo, StartTime, EndTime);
    },
    submitPrice: function (picList, goodsInfo) {
      this.judgeAddorEdit(picList, goodsInfo, "");
    },

    judgeAddorEdit(picList, goodsInfo, StartTime, EndTime) {
      let goodsGuid = this.editForm.CommodityGUID || "";
      let newGoodsGuid = "";
      if (goodsGuid != "") {
        this.setSubmitData(
          picList,
          goodsInfo,
          StartTime,
          EndTime,
          goodsGuid,
          newGoodsGuid
        );
      } else {
        this.$api.returnGuid().then((guid) => {
          this.setSubmitData(
            picList,
            goodsInfo,
            StartTime,
            EndTime,
            goodsGuid,
            guid
          );
        });
      }
    },

    setSubmitData: function (
      picList,
      goodsInfo,
      StartTime,
      EndTime,
      goodsGuid,
      newGoodsGuid
    ) {
      let {AutomaticOffShelf,videoList,goodsType} = this.editForm;
      let personInfo = this.personInfo;
      let transactionName = "";
      let Parameter2 = [];
      let DParameter3 = [];
      for (let i in picList) {
        let obj = {
          CommodityGUID: goodsGuid || newGoodsGuid,
          MultimediaType: picList[i].MultimediaType,
          MultimediaURL: picList[i].MultimediaURL,
        };
        Parameter2.push(obj);
      }
      for(let i in videoList){
        let obj = {
          CommodityGUID: goodsGuid || newGoodsGuid,
          MultimediaType: videoList[i].MultimediaType,
          MultimediaURL: videoList[i].MultimediaURL,
        };
        Parameter2.push(obj);
      }
      let detailList = this.editForm.detailList;
      for (let i in detailList) {
        let obj = {
          CommodityGUID: goodsGuid || newGoodsGuid,
          CommodityDetailsPagePicURL: detailList[i].MultimediaURL,
        };
        DParameter3.push(obj);
      }
      let data = [
        {
          SqlCmdName: "ShopWebApp\\UpdateLotCommodityInfo_1_0_1",
          DBC: "w_m",
          Parameter: "",
        },
        {
          SqlCmdName: "ShopWebApp\\InsertCommodityMultimediaInfo_1_0_1",
          DBC: "w_m",
          Parameter: JSON.stringify(Parameter2),
        },
        {
          SqlCmdName: "ShopWebApp\\InsertCommodityDetailsPagePic_1_0_1",
          DBC: "w_m",
          Parameter: JSON.stringify(DParameter3),
        },
      ];
      let Parameter1 = [
        {
          CommodityGUID: goodsGuid || newGoodsGuid,
          CommodityName: goodsInfo.CommodityName,
          CommodityDescription: goodsInfo.CommodityDescription,
          OriginalPrice:
            goodsInfo.OriginalPrice > 0 ? goodsInfo.OriginalPrice : 0,
          VipPrice: goodsInfo.VipPrice,
          CommodityTypeGUID: goodsInfo.CommodityTypeGUID,
          SharePercentage: ((goodsInfo.SharePercentage || 0) / 100).toFixed(2),
          Guaranteed7Days: goodsInfo.Guaranteed7Days ? 1 : 0,
          FreeShipping: goodsInfo.FreeShipping ? 1 : 0,
          ShopGUID: personInfo.ShopGUID,
          CompanyGUID: personInfo.CompanyGUID,
        },
      ];
      if (goodsType == 1) {
        //拍卖
        Parameter1[0].StartTime = StartTime;
        Parameter1[0].EndTime = EndTime;
        Parameter1[0].ReservePrice = goodsInfo.ReservePrice || 0;
        Parameter1[0].StartingPrice = goodsInfo.StartingPrice || 0;
        Parameter1[0].PriceIncreaseRange = goodsInfo.PriceIncreaseRange || 0;
        Parameter1[0].ReservePrice = goodsInfo.ReservePrice || 0;
        Parameter1[0].RedPackets = (goodsInfo.RedPackets || 0) / 100;

        Parameter1[0].Bond = goodsInfo.Bond || 0;
        if (goodsGuid == "") {
          transactionName = "发布拍卖商品";
          let Parameter3 = [
            {
              CommodityGUID: newGoodsGuid,
            },
          ];
          let dataObj = {
            SqlCmdName: "ShopWebApp\\InsertLotCommodityRobotInfo_1_0_1",
            DBC: "w_m",
            Parameter: JSON.stringify(Parameter3),
          };
          data.push(dataObj);
        } else {
          transactionName = "修改拍卖商品";
        }
      } else {
        //一口价
        data[0].SqlCmdName = "ShopWebApp\\UpdateOrdinaryCommodityInfo_1_0_3";
        if (goodsGuid == "") {
          transactionName = "发布一口价商品";
        } else {
          transactionName = "修改一口价商品";
        }
        Parameter1[0].Price = goodsInfo.Price || 0;
        Parameter1[0].AutomaticOffShelf = AutomaticOffShelf ? 1 : 0;
        Parameter1[0].Number = AutomaticOffShelf ? 1 : 99999;
      }
      data[0].Parameter = JSON.stringify(Parameter1);
      if (goodsGuid == "") {
        this.releaseGoods(transactionName, data, goodsGuid, newGoodsGuid);
      } else {
        this.delPic(goodsGuid, transactionName, data);
      }
    },

    delPic(goodsGuid, transactionName, submitaData) {
      let sqlCmdName =
        "ShopWebApp\\DeleteCommodityMultimediaInfo_1_0_1&DBC=w_m";
      let data = [
        {
          CommodityGUID: goodsGuid,
        },
      ];
      this.$loading();
      this.$api.ExSqlFn(sqlCmdName, JSON.stringify(data)).then((res) => {
        let result = res.data;
        if (result.OK != "True") {
          this.$loading().close();
          this.$message(result.Message);
        } else {
          this.releaseGoods(transactionName, submitaData, goodsGuid, "");
        }
      });
    },
    releaseGoods: function (
      transactionName,
      submitaData,
      goodsGuid,
      newGoodsGuid
    ) {
      let goodsType = this.editForm.goodsType;
      this.$loading();
      this.$api
        .exsqlDistributedUrl(transactionName, JSON.stringify(submitaData))
        .then(
          (res) => {
            this.$loading().close();
            let result = res.data;
            if (result.OK != "True") {
              this.$message(result.Message);
            } else {
              let delFileList = this.delFileList;
              if (delFileList.length > 0) {
                this.deletePicFile(delFileList, 0, 2, goodsGuid, newGoodsGuid);
              } else {
                //判断是否是新增拍卖
                // 新增拍卖则去添加护盘计划
                if (goodsType == 1 && newGoodsGuid != "") {
                  this.insertProtectionPlan(newGoodsGuid);
                } else {
                  this.editFormVisible = false;
                  this.search();
                }
              }
              
              this.$refs.editForm && this.$refs.editForm.resetFields();
              this.$refs['editForm'].clearValidate();
              this.editForm=editForm
            }
          },
          (err) => {
            this.$loading().close();
            this.$message(err);
          }
        );
    },

    returndate(str) {
      str = str.replace(/-/g, "/");
      return new Date(str);
    },

    insertProtectionPlan(goodsGuid) {
      let sqlCmdName = "Currency\\InsertProtectionPlan_1_0_1&DBC=w_m";
      let goodsInfo = this.editForm;
      let EndTime = this.returndate(goodsInfo.EndTime),
        StartTime = this.returndate(goodsInfo.StartTime);
      let RandomSeconds = (EndTime.getTime() - StartTime.getTime()) / 1000;
      RandomSeconds = Math.ceil((Math.random() * RandomSeconds) / 3);
      let data = [
        {
          CommodityGUID: goodsGuid,
          CurrentPrice:
            parseFloat(goodsInfo.StartingPrice || 0) -
            parseFloat(goodsInfo.PriceIncreaseRange),
          RandomSeconds: RandomSeconds,
          InsertNewPlan: 1,
        },
      ];
      this.$loading();
      this.$api.ExSqlFn(sqlCmdName, JSON.stringify(data)).then(
        (res) => {
          let result = res.data;
          if (result.OK != "True") {
            this.$loading().close();
            this.$message(result.Message);
          } else if (result.Tag.length <= 0) {
            this.$loading().close();
            this.$message("添加拍卖护盘机器人失败");
          } else {
            this.$loading().close();
            this.editFormVisible = false;
            this.search();
          }
        },
        (err) => {
          this.$loading().close();
          this.$message(err);
        }
      );
    },
    // 删除
    deleteFn(index, row) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delGoodsFn(row);
        })
        .catch(() => {});
    },
    delGoodsFn(e) {
      console.log(e, 1541);
      let currentGuid =
        e.CommodityGUID || e.SpecialSessionGUID || e.BlindBoxGUID;
      let goodsType = this.editForm.goodsType;
      let sqlCmdName = "ShopWebApp\\DeleteLotCommodity_1_0_1";
      let data = {
        CommodityGUID: currentGuid,
      };
      if (goodsType == 2) {
        sqlCmdName = "ShopWebApp\\DeleteOrdinaryCommodity_1_0_1";
      } else if (goodsType == 3) {
        data = {
          SpecialSessionGUID: currentGuid,
        };
        sqlCmdName = "ShopWebApp\\DeleteSpecialSession_1_0_1";
      } else if (goodsType == 4) {
        data = {
          BlindBoxGUID: currentGuid,
        };
        sqlCmdName = "ShopWebApp\\DeleteBlindBox_1_0_1";
      }
      this.$loading();
      this.$api
        .ExSqlFn(sqlCmdName + "&DBC=w_m", JSON.stringify(data))
        .then((res) => {
          this.$loading().close();
          let result = res.data;
          if (result.OK != "True") {
            this.$message(result.Message);
          } else if (result.Tag.length <= 0) {
            this.$message("删除失败");
          } else {
            this.$message("删除成功");
            this.search();
          }
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },

    beforeUploadVideo(file) {
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
    },
    beforeUpload(file) {
      let imgarr = ["image/png", "image/jpeg", "image/JPG"];
      if (imgarr.indexOf(file.type) == -1) {
        this.$message.error("请上传正确的图片");
        return false;
      }
    },

    /**
     * @param file
     * @return base64
     * */
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        //开始转
        reader.onload = function () {
          fileResult = reader.result;
        };
        //转 失败
        reader.onerror = function (error) {
          reject(error);
        };
        //转 结束  咱就 resolve 出去
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },

    uploadImg(file) {
      this.setBase64(file, 1);
    },

    uploadImg1(file) {
      this.setBase64(file, 2);
    },

    uploadVideo(e) {
      this.setBase64(e, 3);
    },
    uploadImg4(file) {
      this.setBase64(file, 4);
    },
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = Math.floor(event.percent);
    },

    // 3. 上传成功，视频显示是在上传成功后后台返回视频地址，直接显示在页面中的
    handleVideoSuccess(res, file) {
      //获取上传图片地址
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      if (res.stat == 1) {
        this.$message.success("视频上传成功!");
      } else {
        this.$message.error("视频上传失败，请重新上传!");
      }
    },
    setBase64(file, index) {
      this.getBase64(file.raw).then((res) => {
        let data = res.split(",")[1];
        this.$api.returnGuid().then((res) => {
          this.UpLoadFile(res, file, data, index);
        });
      });
    },
    UpLoadFile(guid, file, data, index) {
      let type = file.name;
      type = type.split(".");
      let imgUrl = guid + "." + type[1],
        FilePath =
          index < 3
            ? "images/GoodsPic"
            : index == 3
            ? "video/GoodsVideo"
            : "images/SpecialPic";
      let url =
        imgUrl +
        "&FilePath=" +
        FilePath +
        "&AppendSize=" +
        file.size +
        "&AppendComplete=true";
      let path = file.raw.type;
      this.$loading();
      this.$api.upLoad(url, data).then((res) => {
        this.$loading().close();
        let obj = {
          MultimediaType: path.split("/")[0],
          name: imgUrl,
          MultimediaURL: imgUrl,
          MultimediaName: imgUrl,
          CommodityGUID: guid,
          FilePath: path,
        };
        if (index == 1) {
          //商品主图
          obj.url = this.$goodUrl + "/" + imgUrl;
          this.editForm.picList.push(obj);
        } else if (index == 2) {
          //商品详情图
          obj.url = this.$goodUrl + "/" + imgUrl;
          this.editForm.detailList.push(obj);
        } else if (index == 3) {
          //商品视频
          obj.url = this.$videoUrl + "/" + imgUrl;
          let arr = [];
          arr.push(obj);
          this.editForm.videoList = arr;
        } else if (index == 4) {
          //盲盒图片
          this.editForm.SpecialSessionPicURL = imgUrl;
        }
        this.$message.success(res.data.Message);
      });
    },
    handleRemove4(e) {
      this.handleRemove(e, 4);
    },
    handleRemove(e, index) {
      index = index || 3;
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (
          ["mp4", "ogg", "flv", "avi", "wmv", "rmvb"].indexOf(
            e.MultimediaType
          ) == -1
        ) {
          this.delUpload(e, index);
        } else {
          this.delUpload(e, index);
        }
      });
    },
    delUpload(e, index) {
      //删除图片
      let key =
        index == 1
          ? "picList"
          : index == 2
          ? "detailList"
          : index == 4
          ? "SpecialSessionPicURL"
          : "";
      if (index > 0) {
        if (index < 3) {
          this.editForm[key].forEach((item, i) => {
            if (item.CommodityGUID == e.CommodityGUID) {
              this.editForm[key].splice(i, 1);
            }
          });
        } else if (index == 4) {
          this.editForm[key] = {};
        } else {
          this.editForm["videoList"] = [];
        }
      }
      let delFileInfo = {
        fileName: e.name,
        filePath: index > 0 ? "images/GoodsPic" : "video/GoodsVideo",
      };
      if (this.editForm.CommodityGUID == "") {
        let delFileArr = [];
        delFileArr.push(delFileInfo);
        this.deletePicFile(delFileArr, 0, 1, "", "");
      } else {
        this.delFileList.push(delFileInfo);
      }
    },

    deletePicFile(delFileList, delIndex, type, goodsGuid, newGoodsGuid) {
      this.$loading();
      this.$api
        .deleteFn(
          "?FileName=" +
            delFileList[delIndex].fileName +
            "&FilePath=" +
            delFileList[delIndex].filePath
        )
        .then((res) => {
          let result = res.data;
          this.$loading().close();
          if (result.OK != "True") {
            this.$message(result.Message);
          } else {
          }
          delIndex++;
          if (delFileList.length > delIndex) {
            this.deletePicFile(
              delFileList,
              delIndex,
              type,
              goodsGuid,
              newGoodsGuid
            );
          } else {
            if (type == 2) {
              //判断是否是新增拍卖
              // 新增拍卖则去添加护盘计划
              if (this.editForm.goodsType == 1 && newGoodsGuid != "") {
                this.insertProtectionPlan(newGoodsGuid);
              }
            } else {
              this.$loading().close();
            }
          }
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleImgToUp(item, i) {
      //把图片置顶
      let key = i == 1 ? "picList" : "detailList",k=i == 1 ?'MultimediaGUID':'CommodityDetailsPagePicGUID';
      console.log(this.editForm,2222)
      let list = this.editForm[key];
      if (list.length < 2) {
        return;
      }
      list.forEach((ite, i) => {
        if (ite[k] == item[k]) {
          list.splice(i, 1);
        }
      });
      console.log(item,222)
      list.unshift(item);
      this.editForm[key] = list;
    },
    changeTime(e) {
      console.log(e, 1275);
      // editForm.atSellSwitch,editForm.StartTime
      let nowTime = new Date();
      if (
        new Date(this.editForm.StartTime).getTime() - nowTime.getTime() <=
        1
      ) {
        this.editForm.atSellSwitch = true;
      }
    },

    releaseSpecial: function (transactionName, submitaData) {
      this.$loading();
      this.$api
        .exsqlDistributedUrl(transactionName, JSON.stringify(submitaData))
        .then((res) => {
          let result = res.data;
          console.log(result, 16999);
          this.$loading().close();
          this.$refs.editForm && this.$refs.editForm.resetFields();
          this.$refs['editForm'].clearValidate();
          this.editForm=editForm
          if (result.OK != "True") {
            this.$message(result.Message);
          } else {
            this.search();
            this.editFormVisible = false;
          }
        });
    },

    //穿梭框数据
    createGenerateData() {
      const generateData = (_) => {
        const data = [];
        const students = this.goodsList;

        students.forEach((item) => {
          data.push({
            label: item.CommodityName,
            key: item.CommodityGUID,
          });
        });
        return data;
      };
      this.goodsList = generateData();
    },
    getGoodsList() {
      let goodsList = [],
        { searchName, goodsType } = this.editForm;
      goodsType = goodsType > 0 ? goodsType : this.formInline.goodsType;
      let sqlCmdName =
        goodsType == 3
          ? "ShopWebApp\\GetSpecialSessionAllCommoditys_1_0_1"
          : "ShopWebApp\\GetAllBlindBoxCommoditys_1_0_1"; //specialType=3为盲盒
      let data = {
        ShopGUID: this.personInfo.ShopGUID,
        CompanyGUID: this.personInfo.CompanyGUID,
        CommodityName: searchName || "",
      };
      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        let result = res.data;
        this.$loading().close();
        if (result.OK != "True") {
          this.$message(result.Message);
        } else if (result.Tag.length <= 0) {
        } else {
          goodsList = result.Tag[0].Table;
          goodsList.forEach((item) => {
            item.active = false;
          });
        }
        this.goodsList = goodsList;
        this.getSpecialDetail(goodsType);
        console.log(goodsList, 1446);
      });
    },
    handleChangeGoodsList(e) {
      console.log(e, 146999);
      this.editForm.choosedArr1.push(e);
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.commodityPicUR {
  width: 60px;
  height: 100px;
}

.userRole {
  width: 100%;
}

.gray {
  color: gray;
}

.arrow {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #a0cfff;
  color: #fff;
  background-color: #a0cfff;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  margin: 0 20px;
}

.arrow1 {
  background-color: #409eff;
  border-color: #409eff;
}

.scrollBox {
  width: 300px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  position: relative;
  height: 350px;
  padding: 0 0 0 20px;
  font-size: 14px;
}

.rightContent {
  width: auto;
  min-width: 320px;
}

.scrollView {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  height: 312px;
  overflow: scroll;
}

.scrollView .el-radio {
  height: 28px;
  line-height: 28px;
}

.goodsUl {
  height: 300px;
  overflow-y: scroll;
  margin-top: 20px;
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.goodsLi {
  padding: 10px;
  height: 210px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.goodsLi:last-child {
  border-bottom: 0;
}

.activeGoods {
  box-shadow: 0px 0px 5px 0 rgba(0, 0, 0, 0.3) inset;
}

.activeGoods .title {
  color: #f65353;
}

.goodsImg {
  width: 200px;
  height: 200px;
  margin: 0 20px;
}

.CommodityNature {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  border-radius: 20px;
  -webkit-border-radius: 20px;
  font-size: 12px;
  color: #f9f9f9;
  background: #f65353;
  margin-right: 50px;
}
</style>
<style>
.editor-upload1 {
  width: 700px;
  height: 350px;
  text-align: center;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.editor-upload1 .el-upload--text {
  width: 700px;
  height: 350px;
  line-height: 350px;
}

.upload1-avatar {
  width: 700px;
  height: 350px;
  position: relative;
}

.absolute {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9;
  font-size: 36px;
}

.editor-upload1 .el-upload--picture-card i {
  height: 30px;
}
</style>





// WEBPACK FOOTER //
// src/views/goods/Goods.vue